<template>
  <div>
    <div class="ig_backdrop" v-show="isOpen" @click="closeModal"></div>
    <div class="ig_modal" v-show="isOpen">
      <div class="ig_modal__title">
        Selecione uma imagem:
        <div class="select_file" @click="selectFromPc">
          <i class="material-icons">add_photo_alternate</i>
          selecione do computador
        </div>
      </div>
      <div class="ig_modal__scroll">
        <div class="image-navigator">
          <div class="image-navigator__navigator">
            <fluke-image-navigator
              hide-edit-in-place
              hide-move-multi
              hide-folder-actions
              :categories="imageCategories"
              :images="images"
              :selected-category="selectedCategory"
              :selected-image="selectedImage"
              :uploading="uploadingOrLoading"
              @select-category="onSelectCategory"
              @select-image="onSelectImage"
            ></fluke-image-navigator>
          </div>
        </div>
      </div>
    </div>
    <input
      type="file"
      ref="ig_inputfile"
      class="ig_inputfile"
      @change="setFromPc"
    />
  </div>
</template>

<script>
import axios from "axios";
import ImageNavigator from "../ImageNavigator/ImageNavigator.vue";
import permission from "../../../../mixins/permissions";

export default {
  mixins: [permission],
  components: {
    "fluke-image-navigator": ImageNavigator,
  },
  props: {
    initialCategoryName: String,
  },
  data: function () {
    return {
      isOpen: false,
      images: [],
      imageCategories: [],
      permission: {
        read: false,
        write: false,
      },
      selectedImage: null,
      selectedCategory: null,
      uploading: false,
      loading: false,
    };
  },
  created: function () {
    this.permission = this.getUserPagePermission("images");
  },
  methods: {
    open() {
      this.isOpen = true;
      if (this.images.length === 0) {
        if (this.permission.read == true) {
          this.getCategories().then(() => {
            if (this.imageCategories.length > 0) {
              let selectCategory = this.imageCategories.find((category) => {
                if (this.initialCategoryName) {
                  return category.name
                    .toLowerCase()
                    .includes(this.initialCategoryName.toLowerCase());
                }
                return false;
              });
              if (!selectCategory) {
                selectCategory = this.imageCategories[0];
              }
              this.onSelectCategory(selectCategory);
            }
          });
        }
      }
    },
    selectFromPc() {
      this.$refs.ig_inputfile.click();
    },
    closeModal() {
      this.isOpen = false;
    },
    setFromPc() {
      this.uploading = true;
      const formData = new FormData();
      formData.append("files", this.$refs.ig_inputfile.files[0]);
      formData.set("image_category_id", this.selectedCategory);

      const config = {
        headers: {
          "Content-Type": "multipart/form-data",
          "X-Fluke": this.$cookies.get("token"),
        },
      };

      axios
        .post(this.$myServerAddresses.images, formData, config)
        .then((result) => {
          if (result.data.success) {
            this.getAll(this.selectedCategory);
            this.onSelectImage({
              name: result.data.filename,
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.uploading = false;
          this.$refs.ig_inputfile.value = "";
        });
    },
    async getAll(categoryId) {
      this.loading = true;
      const result = await axios.get(
        this.$myServerAddresses.images +
          "images?image_category_id=" +
          categoryId,
        {
          headers: {
            "X-Fluke": this.$cookies.get("token"),
          },
        }
      );
      this.images = result.data;
      this.loading = false;
    },
    async getCategories() {
      const result = await axios.get(
        this.$myServerAddresses.images + "images/categories",
        {
          headers: {
            "X-Fluke": this.$cookies.get("token"),
          },
        }
      );
      this.imageCategories = result.data;
    },
    onSelectImage(image) {
      this.selectedImage = image.name;
      const imageURL = this.$myServerAddresses.images + "img/" + image.name;
      this.$attrs.value = imageURL;
      this.$emit("input", imageURL);
      this.isOpen = false;
    },
    onSelectCategory(category) {
      this.selectedImage = null;
      this.selectedCategory = category.id;
      this.getAll(category.id);
    },
  },
  computed: {
    uploadingOrLoading() {
      return this.uploading || this.loading;
    },
  },
};
</script>

<style lang="scss">
.ig_inputfile {
  display: none;
}
.ig_backdrop {
  z-index: 3000;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.ig_modal {
  z-index: 3001;
  position: fixed;
  top: 80px;
  left: 100px;
  width: calc(100% - 200px);
  height: calc(100% - 160px);
  background: white;

  .ig_modal__title {
    padding: 20px;
    height: 70px;
    font-size: 22px;
    font-weight: 300;
    position: relative;

    .select_file {
      position: absolute;
      font-size: 15px;
      right: 20px;
      top: 20px;
      padding: 8px 20px;
      border-radius: 3px;
      background-color: #777;
      color: #fff;
      cursor: pointer;

      i {
        margin-top: -4px;
        vertical-align: middle;
      }

      &:hover {
        background-color: #ffc20e;
        color: inherit;
      }
    }
  }

  .ig_modal__scroll {
    height: calc(100% - 90px);
    overflow-y: auto;
    width: calc(100% - 20px);
    padding-left: 20px;

    .ig_modal__images {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-gap: 20px;
      @media (min-width: 768px) {
        grid-template-columns: repeat(3, 1fr);
      }
      @media (min-width: 1024px) {
        grid-template-columns: repeat(4, 1fr);
      }
      img {
        width: 100%;
        height: 200px;
        object-fit: cover;
        opacity: 0.8;
        box-sizing: border-box;
        display: block;
        cursor: pointer;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}

.image-navigator {
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  &__navigator {
    flex-grow: 1;
  }
}
</style>
